import React from 'react';
import { Package, RefreshCw, Clock, Shield, Truck, Globe } from 'lucide-react';
import Header24 from './components/Header24';
import Footer24 from './components/Footer24';

const ShippingAndExchange24 = () => {
    const shippingMethods = [
        {
            icon: Truck,
            title: 'Standard Delivery',
            time: '5-7 business days',
            detail: 'Complimentary on orders above \u20B910,000. \u20B9500 for orders below.',
        },
        {
            icon: Clock,
            title: 'Express Delivery',
            time: '2-3 business days',
            detail: '\u20B9800 flat rate. Available for select metros.',
        },
        {
            icon: Globe,
            title: 'International Shipping',
            time: '10-15 business days',
            detail: 'Available to 30+ countries. Charges calculated at checkout.',
        },
    ];

    const returnSteps = [
        { num: '01', title: 'Initiate Return', desc: 'Contact us within 14 days of delivery at returns@dhara.in with your order number.' },
        { num: '02', title: 'Pack Your Item', desc: 'Place the unworn item with all tags attached in its original packaging.' },
        { num: '03', title: 'Ship It Back', desc: 'Use the prepaid return label we send you. Drop off at any courier partner location.' },
        { num: '04', title: 'Receive Refund', desc: 'Once inspected, your refund will be processed within 7-10 business days.' },
    ];

    return (
        <>
            <style>{`
                @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,500;0,600;0,700;0,800;1,400;1,500&family=Inter:wght@300;400;500;600;700&display=swap');

                .dhara-shipping {
                    min-height: 100vh;
                    background: #FFFFFF;
                }
                .dhara-shipping-hero {
                    max-width: 760px;
                    margin: 0 auto;
                    padding: 80px 40px 0;
                    text-align: center;
                }
                .dhara-shipping-title {
                    font-family: 'Playfair Display', serif;
                    font-size: 42px;
                    font-weight: 400;
                    color: #1A1A1A;
                    margin-bottom: 16px;
                    letter-spacing: -0.5px;
                }
                .dhara-shipping-subtitle {
                    font-family: 'Inter', sans-serif;
                    font-size: 16px;
                    color: #6B6B6B;
                    font-weight: 300;
                    line-height: 1.7;
                    max-width: 520px;
                    margin: 0 auto;
                }

                /* Shipping Methods */
                .dhara-shipping-methods {
                    max-width: 1000px;
                    margin: 0 auto;
                    padding: 80px 40px;
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    gap: 32px;
                }
                .dhara-shipping-method {
                    padding: 40px 32px;
                    border: 1px solid #E5E5E5;
                    text-align: center;
                    transition: border-color 0.3s ease;
                }
                .dhara-shipping-method:hover {
                    border-color: #00553A;
                }
                .dhara-shipping-method-icon {
                    color: #00553A;
                    margin-bottom: 20px;
                }
                .dhara-shipping-method-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-bottom: 8px;
                    letter-spacing: 0.5px;
                }
                .dhara-shipping-method-time {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #00553A;
                    font-weight: 500;
                    margin-bottom: 12px;
                }
                .dhara-shipping-method-detail {
                    font-family: 'Inter', sans-serif;
                    font-size: 13px;
                    color: #6B6B6B;
                    line-height: 1.6;
                }

                /* Divider */
                .dhara-shipping-divider {
                    max-width: 1000px;
                    margin: 0 auto;
                    padding: 0 40px;
                }
                .dhara-shipping-divider-line {
                    height: 1px;
                    background: #E5E5E5;
                }

                /* Returns Section */
                .dhara-shipping-returns {
                    max-width: 760px;
                    margin: 0 auto;
                    padding: 80px 40px;
                }
                .dhara-shipping-section-label {
                    font-family: 'Inter', sans-serif;
                    font-size: 11px;
                    font-weight: 600;
                    letter-spacing: 3px;
                    text-transform: uppercase;
                    color: #00553A;
                    margin-bottom: 20px;
                    text-align: center;
                }
                .dhara-shipping-section-heading {
                    font-family: 'Playfair Display', serif;
                    font-size: 32px;
                    font-weight: 400;
                    color: #1A1A1A;
                    text-align: center;
                    margin-bottom: 16px;
                    letter-spacing: -0.5px;
                }
                .dhara-shipping-section-body {
                    font-family: 'Inter', sans-serif;
                    font-size: 15px;
                    color: #6B6B6B;
                    line-height: 1.8;
                    font-weight: 300;
                    text-align: center;
                    margin-bottom: 60px;
                    max-width: 560px;
                    margin-left: auto;
                    margin-right: auto;
                }

                /* Steps */
                .dhara-shipping-steps {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 32px;
                }
                .dhara-shipping-step {
                    padding: 32px;
                    background: #FAFAF8;
                }
                .dhara-shipping-step-num {
                    font-family: 'Playfair Display', serif;
                    font-size: 32px;
                    font-weight: 300;
                    color: #00553A;
                    opacity: 0.4;
                    margin-bottom: 16px;
                }
                .dhara-shipping-step-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-bottom: 8px;
                }
                .dhara-shipping-step-desc {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    line-height: 1.7;
                    font-weight: 300;
                }

                /* Policy Notes */
                .dhara-shipping-notes {
                    max-width: 760px;
                    margin: 0 auto;
                    padding: 0 40px 120px;
                }
                .dhara-shipping-note-card {
                    padding: 40px;
                    background: #F0F7F4;
                    margin-bottom: 24px;
                }
                .dhara-shipping-note-title {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    font-weight: 500;
                    color: #1A1A1A;
                    margin-bottom: 12px;
                    display: flex;
                    align-items: center;
                    gap: 12px;
                }
                .dhara-shipping-note-text {
                    font-family: 'Inter', sans-serif;
                    font-size: 14px;
                    color: #6B6B6B;
                    line-height: 1.8;
                    font-weight: 300;
                }

                @media (max-width: 768px) {
                    .dhara-shipping-hero { padding: 40px 20px 0; }
                    .dhara-shipping-title { font-size: 32px; }
                    .dhara-shipping-methods {
                        grid-template-columns: 1fr;
                        padding: 48px 20px;
                    }
                    .dhara-shipping-returns { padding: 48px 20px; }
                    .dhara-shipping-section-heading { font-size: 26px; }
                    .dhara-shipping-steps { grid-template-columns: 1fr; }
                    .dhara-shipping-notes { padding: 0 20px 80px; }
                    .dhara-shipping-note-card { padding: 24px; }
                }
            `}</style>

            <Header24 />

            <main className="dhara-shipping">
                {/* Hero */}
                <div className="dhara-shipping-hero">
                    <h1 className="dhara-shipping-title">Shipping & Returns</h1>
                    <p className="dhara-shipping-subtitle">
                        We take great care in packaging each piece. Every order is wrapped in
                        reusable muslin and delivered with love.
                    </p>
                </div>

                {/* Shipping Methods */}
                <div className="dhara-shipping-methods">
                    {shippingMethods.map((method, i) => (
                        <div key={i} className="dhara-shipping-method">
                            <method.icon size={28} strokeWidth={1.2} className="dhara-shipping-method-icon" />
                            <div className="dhara-shipping-method-title">{method.title}</div>
                            <div className="dhara-shipping-method-time">{method.time}</div>
                            <div className="dhara-shipping-method-detail">{method.detail}</div>
                        </div>
                    ))}
                </div>

                <div className="dhara-shipping-divider">
                    <div className="dhara-shipping-divider-line" />
                </div>

                {/* Returns */}
                <div className="dhara-shipping-returns">
                    <div className="dhara-shipping-section-label">Returns & Exchanges</div>
                    <h2 className="dhara-shipping-section-heading">Hassle-Free Returns</h2>
                    <p className="dhara-shipping-section-body">
                        If a piece does not feel right, we make returns simple. Items can be returned
                        within 14 days of delivery in their original condition.
                    </p>

                    <div className="dhara-shipping-steps">
                        {returnSteps.map((step, i) => (
                            <div key={i} className="dhara-shipping-step">
                                <div className="dhara-shipping-step-num">{step.num}</div>
                                <div className="dhara-shipping-step-title">{step.title}</div>
                                <div className="dhara-shipping-step-desc">{step.desc}</div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Notes */}
                <div className="dhara-shipping-notes">
                    <div className="dhara-shipping-note-card">
                        <div className="dhara-shipping-note-title">
                            <Shield size={18} strokeWidth={1.5} color="#00553A" />
                            Exchange Policy
                        </div>
                        <p className="dhara-shipping-note-text">
                            We offer one-time exchanges for a different size within 14 days of delivery.
                            The item must be in its original condition with tags attached. Exchange
                            shipping is complimentary within India.
                        </p>
                    </div>
                    <div className="dhara-shipping-note-card">
                        <div className="dhara-shipping-note-title">
                            <RefreshCw size={18} strokeWidth={1.5} color="#00553A" />
                            Non-Returnable Items
                        </div>
                        <p className="dhara-shipping-note-text">
                            Custom or made-to-order pieces, altered garments, and items purchased during
                            final sale are not eligible for returns or exchanges. Saris that have been
                            unpleated are also non-returnable.
                        </p>
                    </div>
                    <div className="dhara-shipping-note-card">
                        <div className="dhara-shipping-note-title">
                            <Package size={18} strokeWidth={1.5} color="#00553A" />
                            Packaging
                        </div>
                        <p className="dhara-shipping-note-text">
                            All Dhara pieces are carefully wrapped in reusable muslin cloth and packed in
                            recycled paper boxes. We encourage you to reuse or recycle the packaging.
                            Our commitment to sustainability extends to every detail of your experience.
                        </p>
                    </div>
                </div>
            </main>

            <Footer24 />
        </>
    );
};

export default ShippingAndExchange24;
